import React, { useEffect, useState } from "react";
import { GLOBAL_IMAGES } from "../asset";
import SettingsHeader from "../../components/Profile/SettingsHeader";
import { ChevronDown, ChevronRight, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";
import useIndiaLocation from "../../hooks/useIndiaLocation";

// FAQ data from your input
const FAQ_QUESTIONS = [
  "What is MathDingo?",
  "How does MathDingo personalise learning for my child?",
  "Can MathDingo be used in schools?",
  "What features are available to parents?",
  "Does my child need extra materials like notebooks for rough work?",
  "Is MathDingo aligned with the Australian curriculum?",
  "Is there a free trial available?",
  "How do I get support if I need help with the app?",
  "What devices is MathDingo compatible with?",
  "How can I monitor my child’s progress on MathDingo?",
];

const FAQ_ANSWERS = [
  "MathDingo is a comprehensive maths learning app designed and operated in Australia, specifically for Aussie kids from Foundation to Year 9. Aligned with the Victorian curriculum, it uses AI technology to personalise learning experiences, making maths engaging and effective.",
  "Our app uses advanced AI to assess each child’s strengths and challenges, adapting content to fit their individual learning pace and style. This ensures a personalised, supportive experience that helps students master key maths concepts.",
  "Yes! MathDingo is ideal for classroom use. Schools and educators get access to an exclusive admin panel with tools for customising lessons, setting time limits, assigning content, and more, providing a tailored educational experience.",
  "Parents have access to detailed reports and insights into their child’s performance. With easy-to-understand analytics, parents can see progress, identify areas needing extra support, and stay actively involved in their child’s learning journey.",
  "No extra materials are needed! MathDingo includes a built-in rough board, allowing students to do all their calculations and notes within the app—keeping everything in one place for a seamless learning experience.",
  "Yes, MathDingo aligns with the Victorian curriculum to ensure that all content meets educational standards and supports the skills your child is learning in school.",
  "Absolutely! We offer a free trial period for new users to explore the app and experience its features before subscribing.",
  "For any support or questions, you can contact our friendly customer service team through the app or via our website. We’re here to help make your MathDingo experience as smooth as possible!",
  "MathDingo works on both iOS and Android devices, so you can access it from a smartphone or tablet. Check our website for minimum device specifications to ensure the best experience.",
  "With MathDingo, you’ll receive regular progress updates and detailed performance insights, helping you stay connected with your child’s learning and achievements every step of the way."
];

// Combine into items
const FAQ_ITEMS = FAQ_QUESTIONS.map((question, i) => ({
  question,
  answer: FAQ_ANSWERS[i],
}));

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const isIndiaLocation = useIndiaLocation();
  const visibleFaqItems = isIndiaLocation
    ? FAQ_ITEMS.filter((_, index) => ![0, 5].includes(index))
    : FAQ_ITEMS;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="settings-page min-h-screen flex flex-col bg-blue-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <SettingsHeader name="FAQ" />
      <div className="settings-content bg-white/50 w-[60%] mr-auto ml-auto mt-20 mb-20 p-10 rounded-lg">
        <div className="flex gap-2">
          <Link to={`/settings`}>Settings</Link>
          <ChevronRight />
          <p>FAQ</p>
        </div>
        <h1 className="text-4xl font-bold my-6 text-center">
          Frequently asked questions
        </h1>
        <div>
          {visibleFaqItems.map((item, idx) => (
            <div key={idx} className="mb-2">
              <div
                onClick={() => handleToggle(idx)}
                className="flex justify-between items-center w-full px-4 py-2 bg-white text-base font-medium shadow-md rounded cursor-pointer"
              >
                <span>{item.question}</span>
                {openIndex === idx ? (
                  <ChevronUp className="h-5 w-5" />
                ) : (
                  <ChevronDown className="h-5 w-5" />
                )}
              </div>
              {openIndex === idx && (
                <div className="px-4 py-2 bg-white text-gray-700 shadow-md rounded mt-1">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
        <Link
          to={"/contact"}
          className="mt-8 w-fit mx-auto block bg-blue-900 text-white py-2 px-28  rounded-2xl text-lg font-semibold"
        >
          Contact Us
        </Link>
        <p className="mt-4 text-center text-sm text-gray-900 font-semibold">
          Still unsure about something?
        </p>
      </div>
    </div>
  );
};

export default FAQ;
